import React, { FC, useMemo } from 'react';
import { useMutation } from '@apollo/client';
import CommonLocaleSetting from '../common/Locale';
import GET_GSS_CLASSROOM_SETTINGS from 'graph/settings/gss/get-gss-classroom-settings-query';
import UPDATE_GSS_CLASSROOM_LANGUAGE_SETTING from 'graph/settings/gss/update-gss-classroom-language-setting-mutation';
import { updateCache } from 'graph/update-cache';
import { LocaleClassroomSettingProps } from '../../../../types';
import { useTranslation } from 'react-i18next';

const getClassroomGssSettingsMutationCacheUpdate = (classroomId: number): any => ({
  update: updateCache<any>([
    {
      query: GET_GSS_CLASSROOM_SETTINGS,
      variables: {
        where: {
          classroomId
        }
      },
      reducer: (
        cachedData,
        { updateGssClassroomSettingLanguage }
      ): { gssClassroomSettings: any } => {
        const [{ value }] = updateGssClassroomSettingLanguage;
        return {
          gssClassroomSettings: {
            ...cachedData?.gssClassroomSettings,
            locale: value
          }
        };
      }
    }
  ])
});

const LocaleSetting: FC<LocaleClassroomSettingProps> = props => {
  const { t } = useTranslation('GssLocaleSetting');
  const [updateGssClassroomSettingLanguage] = useMutation(
    UPDATE_GSS_CLASSROOM_LANGUAGE_SETTING,
    getClassroomGssSettingsMutationCacheUpdate(+props.classroom.id)
  );

  const appLocaleSettingsProps = useMemo(
    () => ({
      description: t(
        'Change language setting for Touch & Flip Numbers. (Touch & Flip Numbers is the only module in the GSS Student Learning Apps available in Spanish.)'
      ),
      mutation: updateGssClassroomSettingLanguage
    }),
    [t, updateGssClassroomSettingLanguage]
  );

  return <CommonLocaleSetting {...props} {...appLocaleSettingsProps} />;
};

export default LocaleSetting;
